import type { ElementType, HTMLAttributes } from 'react'
import { cx } from '../cx'
import styles from './Container.module.css'

type ContainerProps = Omit<
  HTMLAttributes<HTMLElement>,
  'style' | 'className'
> & {
  as?:
    | 'div'
    | 'section'
    | 'ul'
    | 'ol'
    | 'li'
    | 'nav'
    | 'header'
    | 'footer'
    | 'main'
    | 'aside'
    | 'article'
    | 'form'
    | 'fieldset'
  size:
    | 'container-form'
    | 'container-reading'
    | 'container-content'
    | 'container-table'
    | 'container-full'
  inset?: boolean
  className?: string
}

export function Container({
  as = 'div',
  size,
  inset,
  className,
  children,
  ...rest
}: ContainerProps) {
  const Tag: ElementType = as
  return (
    <Tag
      {...rest}
      className={cx(styles.container, className)}
      data-size={size}
      data-inset={inset ? '' : undefined}
    >
      {children}
    </Tag>
  )
}
